import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bidi-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  @Output() close = new EventEmitter<any>();

  @Input() active;

  constructor() { }

  closeModal() {
    this.active = false;
    this.close.emit(true);
  }
}
